import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgDogFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M55.956 24.51c0 3.624-.72 7.212-2.117 10.56a27.6 27.6 0 0 1-6.03 8.954 27.8 27.8 0 0 1-9.025 5.983 28 28 0 0 1-21.29 0 27.8 27.8 0 0 1-9.024-5.983 27.6 27.6 0 0 1-6.03-8.953A27.4 27.4 0 0 1 .322 24.51h55.634"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: `dog-fidelity-low_svg__a-${id}`,
        width: 56,
        height: 29,
        x: 0,
        y: 24,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: 'alpha'
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M55.31 24.354a28.1 28.1 0 0 1-2.085 10.62 27.8 27.8 0 0 1-5.937 9.004 27.4 27.4 0 0 1-8.886 6.015 27.1 27.1 0 0 1-10.482 2.113 27.1 27.1 0 0 1-10.482-2.113 27.4 27.4 0 0 1-8.885-6.015 27.8 27.8 0 0 1-5.938-9.004A28.1 28.1 0 0 1 .53 24.354h54.78"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: `url(#dog-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M17.288 42.362c.608-3.947-.254-8.325-.76-10.02l3.041-3.7h19.314l1.216 10.328c.558 2.467 1.795 7.925 2.281 10.021.609 2.621 5.78 10.638 9.277 19.117 2.798 6.784 6.134 25.232 7.452 33.609H28.237c-3.004 0-4.445-.715-5.08-1.419-.148 1.333-.84 3.115-1.611 3.115-1.064 0-3.194.308-5.019 0-1.46-.247-1.115-1.748-.76-2.467h-3.193c-1.977-.154-1.825-3.546-1.37-5.242.457-1.695-5.17-13.875-3.953-18.962.973-4.07 5.272-6.321 7.3-6.938-.508-2.467-1.613-7.955-1.978-10.175-.456-2.775 3.954-12.333 4.715-17.267"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDE9E8",
        d: "m19.177 37.335-.173-.613 3.94-8.08 9.92.682.63 2.75c-.543.433.905 2.522 1.695 4.862.726 1.179 1.24 3.787 1.472 6.788.118 1.524.238 3.063.238 4.38 0 2.402.859 3.196 1.847 4.109.622.574 1.295 1.195 1.837 2.294.605 1.227.982 2.818 1.398 4.573.548 2.315 1.164 4.916 2.461 7.344 1.528 2.859.852 9.468.344 14.43-.25 2.445-.46 4.49-.344 5.489l.142 1.254c.394 3.518 1.142 10.211 2.143 14.12h-18.49c-3.004 0-4.445-.715-5.079-1.419l-.02.156c-.555-.976-1.07-1.962-1.152-2.373-.076-.39-.187-1.568-.317-2.948-.166-1.764-.363-3.858-.56-5.055-.187-1.137.472-3.281 1.102-5.333.554-1.803 1.086-3.534 1.004-4.45-.087-.969-.864-4.08-1.754-7.644-.905-3.624-1.926-7.716-2.457-10.496-1.053-5.513-1.053-9.248 1.053-11.916 2.035-2.58.79-6.988-.88-12.904"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "M38.527 37.157c-1.356 1.723-5.952 5.076-13.487 4.704-7.534-.373-8.154-3.072-7.523-4.375l-.323-5.08 21.548-2.253z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#5F453B",
        d: "M46.047 20.963c-2.098-4.206-3.671-8.12-6.818-9.377-1.192 5.526-3.413 17.148-2.765 19.43.81 2.851.953 9.231 1.049 10.246s.381 1.595 2.717 1.063c4.053-1.256 5.436-2.368 8.63-7.346s-.715-9.812-2.813-14.016M14.834 10.21C18.95 8.15 22.41 6 26.1 6.942c-1.555 5.146-5.103 15.792-6.858 17.212-2.193 1.774-3.882 5.653-4.658 7.731s-3.15 2.085-4.58-1.036c-1.428-3.12-2.572-6.455-2.572-12.255 0-5.986 3.288-6.327 7.403-8.386"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5F453B",
        d: "M46.047 20.962c-2.098-4.205-3.67-8.12-6.817-9.377-1.192 5.526-3.414 17.149-2.766 19.43.81 2.852.954 9.232 1.05 10.247.095 1.015.38 1.595 2.717 1.063 4.052-1.257 5.435-2.368 8.63-7.347 3.194-4.978-.716-9.811-2.814-14.016"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDE9E8",
        d: "M40.314 12.026c-1.672-1.088-4.754-1.4-8.133-2.552-3.378-1.151-5.004-2.66-7.358-2.66-.839.785-2.052 3.367-4.84 6.194-3.47 3.518-3.47 7.085-3.47 10.446v.044c0 2.356-.177 5.974-.37 9.311-.194 3.337.641 5.389 3.143 5.937 1.893.414 3.497.643 4.808 1.625 2.59 1.937 5.376-.863 6.345-2.63s4.035-5.087 6.415-7.181c3.267-2.875 3.46-5.437 3.46-9.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "M33.345 9.844a31 31 0 0 1-1.164-.37c-1.325-.451-2.38-.958-3.316-1.407-1.45-.696-2.612-1.254-4.042-1.254-.312.293-.676.833-1.153 1.542-.807 1.198-1.937 2.877-3.688 4.653-3.47 3.518-3.47 7.085-3.47 10.446v.044c0 1.476-.069 3.446-.168 5.533 1.582-2.144 4.141-4.907 6.949-5.97 3.803-1.439 4.937-4.105 5.837-6.223.194-.457.377-.887.574-1.275.751-1.482 2.5-4.084 3.64-5.719m-.536 24.774c.03-2.17-.24-4.843-1.194-7.495-1.727-4.8-1.125-6.56-.468-8.48.165-.48.332-.969.468-1.518.441-1.791 1.267-5.056 1.824-7.253.916.269 1.797.489 2.62.694 1.762.439 3.259.812 4.255 1.46v8.833c0 4.264-.193 6.826-3.46 9.7a48 48 0 0 0-4.045 4.058",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 1.5,
        cy: 1.519,
        fill: "#231F20",
        rx: 1.5,
        ry: 1.519,
        transform: "matrix(.97354 .22854 -.22268 .9749 21.115 15.704)"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 1.5,
        cy: 1.52,
        fill: "#231F20",
        rx: 1.5,
        ry: 1.52,
        transform: "matrix(.9883 .15255 -.14853 .9889 34.164 20.325)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5F453B",
        d: "M24.148 34.783c-.898.276-2.056-.293-2.36-.887-.302-.593-1.118-2.827-1.264-4.877-.022-1.266.787-2.119 2.168-1.872 2.075.205 3.721.775 5.41 2.014.964.706 1.144 1.767.335 2.786-1.12 1.41-3.39 2.56-4.289 2.836"
    }));
};
export default SvgDogFidelityLow;
